import React from 'react';

import  MenuBar from './menu_bar.jsx';

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="layout">
          <MenuBar />
          <div className="main-view">
            <div className="container">
              {this.props.children}
            </div>
          </div>
      </div>
    );
  }
}

